import { render, staticRenderFns } from "./AdminSaveSeatWidget.vue?vue&type=template&id=ebba8d42&scoped=true&"
import script from "./AdminSaveSeatWidget.vue?vue&type=script&lang=js&"
export * from "./AdminSaveSeatWidget.vue?vue&type=script&lang=js&"
import style0 from "./AdminSaveSeatWidget.vue?vue&type=style&index=0&id=ebba8d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebba8d42",
  null
  
)

export default component.exports